"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "#004864"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20.16,6.85A.49.49,0,0,0,21,6.51V2a.49.49,0,0,0-.49-.49H16a.49.49,0,0,0-.35.86Z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "3.01 12.12 3.01 23.5 10 23.5 10 16.51 14.01 16.51 14.01 23.5 21 23.5 21 12.12 12 3.12 3.01 12.12"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.86,12.16h0L12.35.65a.51.51,0,0,0-.71,0L.14,12.15a.5.5,0,1,0,.7.71h0L12,1.69,23.15,12.84h0a.51.51,0,0,0,.7,0h0A.49.49,0,0,0,23.86,12.16Z"
  }));
};

exports["default"] = _default;